import { BaseRouteService } from "core/services";

class TrackingCaseDocumentStreamRouteService extends BaseRouteService {
    constructor() {
        super("tracking-case-document-streams");
    }

    find(filter) {
        return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields}`, filter);
    }

    get(id, options) {
        return super.get(`${this.base}/{id}{?contentDisposition,embed,fields}`, id, options);
    }

    create(resource) {
        return super.create(`${this.base}/{filename}{?trackingCaseId,description,validFrom,validTo,documentTypeId,documentFormId,name}`, resource);
    }

    update(resource) {
        return super.update(`${this.base}/{id}`, resource);
    }

    delete(resource) {
        return super.delete(`${this.base}/{id}`, resource);
    }
}

export default TrackingCaseDocumentStreamRouteService;